import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormControl} from "@angular/forms";
import {debounceTime, distinctUntilChanged, startWith, take, takeUntil, tap} from "rxjs/operators";
import {ListResponse} from "../../interface/response/list-response";
import {MatSelectChange} from "@angular/material/select";
import {ReplaySubject} from "rxjs";
import {HiperioConfigService} from "../../services/hiperio-config.service";
import {HiperioConfig} from "../../interface/hiperio-config";

@Component({
  selector: 'app-dict-hiperio-config',
  templateUrl: './dict-hiperio-config.component.html',
  styleUrls: ['./dict-hiperio-config.component.scss']
})
export class DictHiperioConfigComponent implements OnInit, ControlValueAccessor, OnDestroy {
  @Input() label: string;
  @Input() multiple = false;
  @Input() control: FormControl = null;
  @Input() required = false;
  @Input() companyId?: ReplaySubject<number>;
  @Input() iddtrainingtrainerId?: ReplaySubject<number>;
  @Input() hideBlocked = false;
  @Input() hideInactive = false;
  @Input() hideChildren = false;
  @Input() forceShowPzu = false;
  @Input() onlyKeys?: string[] = null;
  @Input() showElements = 25;
  @Input() forceShowInsuranceCompanyIds: number[];
  @Output() selectedIddTrainingTrainer: EventEmitter<HiperioConfig> = new EventEmitter<HiperioConfig>();
  @Output() selectedIddTrainingTrainers: EventEmitter<HiperioConfig[]> = new EventEmitter<HiperioConfig[]>();

  externalControl = true;
  isFirstName = true;
  disabled = false;
  items: HiperioConfig[] = [];
  filteredItems: HiperioConfig[] = [];
  value?: string = null;
  filterControl: FormControl;
  itemsSubject: ReplaySubject<ListResponse<HiperioConfig>> = new ReplaySubject<ListResponse<HiperioConfig>>(1);

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private hiperioConfigService: HiperioConfigService,
    private fb: FormBuilder
  ) {
    this.loadItems();
    this.filterControl = fb.control('');
  }

  ngOnInit(): void {
    if (this.control === null) {
      this.control = new FormControl({ value: '' });
      this.externalControl = false;
    }

    this.control.valueChanges
      .pipe(
        startWith(this.control.value),
        takeUntil(this.destroyed$)
      )
      .subscribe((val: number) => {
      });

    this.filterControl.valueChanges
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        takeUntil(this.destroyed$)
      )
      .subscribe((val) => {
        if (!val) {
          this.filteredItems = null;
          return;
        }

        this.filteredItems = this.items;

        this.filteredItems = this.filteredItems.filter((hiperioConfig: HiperioConfig) => {
          return hiperioConfig.insuranceCompany.name.toUpperCase().includes(val.toUpperCase());
        });
      });

  }

  loadItems(): void {
    this.hiperioConfigService.getHiperioConfigSubject()
      .pipe(
        take(1),
      ).subscribe((result: HiperioConfig[]) => {
      this.items = result;
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }


  setDisabledState(isDisabled: boolean): void {
    if (this.externalControl) {
      return;
    }

    if (isDisabled) {
      this.control.disable();
    } else {
      this.control.enable();
    }

    this.disabled = isDisabled;
  }

  writeValue(value: any): void {
    if (this.externalControl) {
      return;
    }

    this.control.setValue(value);
    this.value = value;
  }

  onSelectionChange(e: MatSelectChange): void {
    this.items.forEach((hiperioConfig: HiperioConfig) => {
      if (hiperioConfig.id === e.value) {
        this.selectedIddTrainingTrainer.emit(hiperioConfig);
      }
    });

    this.value = e.value;
    this.onChange(this.value);
  }

  clearValue(): void {
    this.control.setValue(this.multiple ? [] : '');
    this.writeValue(this.multiple ? [] : '');
    this.onChange(this.value);
  }

  onChange: any = () => { };
  onTouched: any = () => { };


}
